import React from "react";
import { formatarCnpjCpf } from "../utils/documento.js";
import { resolverIdentificacaoPrograma } from "../utils/tipoPrograma.js";
import {
  extrairIdItem,
  resolverCnpjItem,
  resolverRazaoSocial,
  resolverNomeAprendiz,
} from "../utils/itemResolvers.js";
import { obterTipoProgramaItem } from "../mappers/empresaMapper.js";
import { obterResumoStatusItem } from "./itemResumo.js";

export const AcompanhamentoItemCard = React.memo(({
  item,
  isSelecionado,
  tipoProgramaLogado,
  ehEstudanteUsuario,
  onSelecionar,
  onAbrirContrato,
  onVerHistorico,
}) => {
  const statusStr = String(
    item?.status ||
    item?.raw?.status ||
    item?.status_label ||
    item?.raw?.status_label ||
    ""
  ).toUpperCase();

  const ehStatusAprendizOuEstudante =
    statusStr.includes("APRENDIZ") ||
    statusStr.includes("ESTUDANTE") ||
    statusStr.includes("EM_PREENCHIMENTO");

  const totalRaw = Number(
    item?.total_etapas ??
    item?.raw?.total_etapas ??
    item?.totalEtapas ??
    item?.raw?.totalEtapas
  );

  const tipoDireto =
    obterTipoProgramaItem(item) ?? obterTipoProgramaItem(item?.raw);

  const tipoProgramaItem = (() => {
    if (tipoDireto !== null && tipoDireto !== undefined) {
      return Number(tipoDireto);
    }
    const raw = item?.raw || item;
    const tipo =
      item?.tipo_programa ??
      item?.tipoPrograma ??
      raw?.tipo_programa ??
      raw?.tipoPrograma;
    const numero = Number(tipo);
    if (Number.isFinite(numero) && (numero === 0 || numero === 1 || numero === 2)) {
      return numero;
    }
    if (ehStatusAprendizOuEstudante || totalRaw === 5) {
      return Number(tipoProgramaLogado) === 0 ? 0 : 2;
    }
    return Number(tipoProgramaLogado);
  })();

  const resumo = obterResumoStatusItem(item, tipoProgramaItem);
  const id = extrairIdItem(item);
  const nomeAp = resolverNomeAprendiz(item);
  const isTca1 =
    Number(tipoProgramaItem) === 1 && !ehStatusAprendizOuEstudante && totalRaw !== 5;
  const razao = resolverRazaoSocial(item);

  const tituloCard = isTca1
    ? (razao ||
        item.razao_social ||
        item.empresa_nome ||
        item.nome_empresa ||
        item.nome ||
        `Empresa #${id}`)
    : (razao ||
        item.empresa_nome ||
        item.nome_empresa ||
        item.razao_social ||
        `Empresa #${id}`);

  const cnpjCard = resolverCnpjItem(item);
  const programa = resolverIdentificacaoPrograma(item.raw || item, cnpjCard);

  const tpCard =
    obterTipoProgramaItem(item) ??
    Number(tipoProgramaItem ?? tipoProgramaLogado);
  const isEstagio = Number(tpCard) === 0;
  const rotuloPessoa = isEstagio
    ? "Estagiário:"
    : /estudante/i.test(resumo.statusLabel) &&
        !item?.nome_aprendiz &&
        !item?.raw?.nome_aprendiz
      ? "Estudante:"
      : "Aprendiz:";

  let labelCard = resumo.statusLabel;
  if (isEstagio) {
    if (
      /aprendiz/i.test(labelCard) ||
      /aguardando preenchimento/i.test(labelCard) ||
      /em preenchimento/i.test(labelCard)
    ) {
      labelCard = "Aguardando Preenchimento do Estagiário";
    }
  } else if (Number(tpCard) === 2) {
    if (/estagi[aá]rio/i.test(labelCard)) {
      labelCard = labelCard.replace(/estagi[aá]rio/gi, "Aprendiz");
    }
  }

  return (
    <div
      className="acompanhamento-card"
      onClick={() => onSelecionar(item)}
      style={
        isSelecionado
          ? { borderColor: "#134b8b", borderWidth: 2 }
          : undefined
      }
    >
      <div className="acompanhamento-card-info">
        <div className="acompanhamento-card-header-linha">
          <span className="acompanhamento-card-badge-id">
            Formulário #{id}
          </span>
          {programa && (
            <span
              style={{
                display: "inline-block",
                padding: "1px 8px",
                borderRadius: 999,
                fontSize: 10,
                fontWeight: 600,
                color: "#721c24",
                backgroundColor: "#f8d7da",
                border: "1px solid #721c24",
                letterSpacing: 0.2,
              }}
            >
              {programa.rotulo}
            </span>
          )}
        </div>

        <h3>{tituloCard}</h3>

        {!isTca1 && nomeAp && (
          <p
            style={{
              margin: "0.25rem 0 0",
              fontSize: 13,
              color: "#1e293b",
              display: "flex",
              alignItems: "center",
              gap: 6,
              flexWrap: "wrap",
              lineHeight: 1.4,
            }}
          >
            <strong style={{ fontWeight: 700, color: "#0f172a" }}>
              {rotuloPessoa}
            </strong>
            <span style={{ color: "#1e293b", fontWeight: 600 }}>
              {nomeAp}
            </span>
          </p>
        )}

        {razao && razao !== tituloCard && (
          <p
            style={{
              margin: "0.15rem 0 0",
              fontSize: 12,
              color: "#475569",
              fontWeight: 500,
            }}
          >
            {razao}
          </p>
        )}

        {cnpjCard && (
          <p
            style={{
              margin: "0.25rem 0 0",
              fontSize: 12,
              color: "#64748b",
              display: "flex",
              alignItems: "center",
              gap: 6,
              flexWrap: "wrap",
            }}
          >
            <span>CNPJ/CPF: {formatarCnpjCpf(cnpjCard)}</span>
          </p>
        )}

        <p
          style={{
            margin: "0.25rem 0 0",
            fontSize: 12,
            color: "#64748b",
          }}
        >
          Etapa {resumo.etapaAtual}/{resumo.totalEtapas} · Progresso{" "}
          {resumo.progresso}%
        </p>
      </div>

      <span
        className="status-badge"
        style={{
          backgroundColor: resumo.statusCor + "22",
          color: resumo.statusCor,
        }}
      >
        {labelCard}
      </span>

      {ehEstudanteUsuario && (
        <div
          style={{
            display: "flex",
            gap: "6px",
            marginLeft: "auto",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <button
            type="button"
            className="acompanhamento-btn-abrir-contrato"
            data-testid={`acompanhamento-btn-contrato-${id}`}
            onClick={(e) => {
              e.stopPropagation();
              onAbrirContrato(item);
            }}
            style={{
              padding: "5px 12px",
              fontSize: 12,
              fontWeight: 600,
              borderRadius: 6,
              border: "none",
              background: "#005ac2",
              color: "#fff",
              cursor: "pointer",
              whiteSpace: "nowrap",
              boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
            }}
            title="Abrir contrato para preenchimento"
          >
            Preencher Contrato
          </button>
          <button
            type="button"
            className="acompanhamento-btn-historico-card"
            data-testid={`acompanhamento-btn-historico-${id}`}
            onClick={(e) => {
              e.stopPropagation();
              onVerHistorico(id);
            }}
            style={{
              padding: "5px 10px",
              fontSize: 12,
              fontWeight: 600,
              borderRadius: 6,
              border: "1px solid #134b8b",
              background: "#fff",
              color: "#134b8b",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
            title="Ver histórico desta autorização"
          >
            Histórico
          </button>
        </div>
      )}
    </div>
  );
});

export default AcompanhamentoItemCard;
